const config = { domain: 'Academy', subdomain: 'Coaching' }

interface TopicClicked {
  topic: string
  userName: string
}

interface ResourceClicked {
  courseId: string
  courseTitle: string
}

interface ScheduleMeetingCompleted {
  userSlug: string
  meetingStart: string
  meetingEnd: string
  contactName: string
  contactEmail: string
  organizerName: string
  organizerEmail: string
}

export const coaching = {
  Topic_Clicked: { Topic_Clicked: (param: TopicClicked) => param, config },
  Clicked: {
    Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Group_Coaching_Clicked: {
    Group_Coaching_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  One_On_One_Coaching_Clicked: {
    One_On_One_Coaching_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Ask_A_Coach_Clicked: {
    Ask_A_Coach_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Scheduler_Clicked: {
    Scheduler_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Resource_Clicked: {
    Resource_Clicked: (param: ResourceClicked) => param,
    config,
  },
  Schedule_Meeting_Completed: {
    Schedule_Meeting_Completed: (param: ScheduleMeetingCompleted) => param,
    config,
  },
}
